export const contactsData = {
    email: 'helpout.avijit.indiacampus@gmail.com',
    phone: '+91 9732439571',
    address: 'Bangalore, Karnataka',

    sheetAPI: 'https://sheetdb.io/api/v1/tt5b8x0x5sbmo'
}
